// Automatically generated in 'npm version' by scripts/genversion.js

'use strict'
const version = '4.8.7';
export default version;
